import { PageProps } from '@/types/PageProps';

import { DefaultRouteTabs } from '@/components/_common';

import { useReleasePurchaseFormContext } from '../../ReleasesPurchaseProvider';
import PurchasesGroupingsList from '@/components/Movements/Purchases/PurchaseDetails/PurchasesGroupingsList';
import { Divider } from 'antd';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import purchaseValidationTabs from '@/utils/functions/purchase/purchaseValidationTabs';

function PurchaseGroupingsPage({ route }: PageProps) {
  const { purchaseId, disabled, purchase } = useReleasePurchaseFormContext();

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={purchaseValidationTabs(route, purchase)}
      baseKey={purchaseId}
      basePath={`/app/movements/purchases/purchasesReleases/${purchaseId}`}
    >
      <PurchasesGroupingsList purchaseId={Number(purchaseId)} />

      <Divider />

      <SpaceForButton>
        <ButtonBack
          path="/app/movements/purchases/purchasesReleases"
          disabled={disabled}
        />
      </SpaceForButton>
    </DefaultRouteTabs>
  );
}

export default PurchaseGroupingsPage;
